import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const MyClassesLazy = React.lazy(
	() => import(/* webpackChunkName : 'MyClasses' */ './components/MyClasses')
);

export default (store) => {
	return [
		{
			path: 'my-classes',
			element: <AsyncLoading component={<MyClassesLazy />} />,
		},
	];
};
